"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IPF_SPAN_TYPES = exports.IPFSpanType = void 0;
exports.isIPFSpanType = isIPFSpanType;
var IPFSpanType;
(function (IPFSpanType) {
    IPFSpanType["FORE_SPAN"] = "fore_span";
    IPFSpanType["BACK_SPAN"] = "back_span";
    IPFSpanType["OTHER"] = "other";
})(IPFSpanType || (exports.IPFSpanType = IPFSpanType = {}));
exports.IPF_SPAN_TYPES = [IPFSpanType.FORE_SPAN, IPFSpanType.BACK_SPAN, IPFSpanType.OTHER];
const ipfSpanSet = new Set(Object.values(IPFSpanType));
function isIPFSpanType(value) {
    return ipfSpanSet.has(value);
}
//# sourceMappingURL=Span.js.map